import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { selectOrgId } from '@/app/module/user/store/selectors'
import { TWhatsappContent } from '@/app/types'
import downloadConfig from '@/config/download'

export const ensureFilesUrl = (orgId: number, content: TWhatsappContent): TWhatsappContent => {
  if ('image' in content) {
    return {
      ...content,
      image: {
        ...content.image,
        files: content.image.files.map((f) => downloadConfig.files.getPath({ orgId, filename: f })),
      },
    }
  }

  if ('audio' in content) {
    return {
      ...content,
      audio: {
        ...content.audio,
        files: content.audio.files.map((f) => downloadConfig.files.getPath({ orgId, filename: f })),
      },
    }
  }

  if ('document' in content) {
    return {
      ...content,
      document: {
        ...content.document,
        files: content.document.files.map((f) => downloadConfig.files.getPath({ orgId, filename: f })),
      },
    }
  }

  if ('video' in content) {
    return {
      ...content,
      video: {
        ...content.video,
        files: content.video.files.map((f) => downloadConfig.files.getPath({ orgId, filename: f })),
      },
    }
  }

  return content
}

export const useEnsureFilesUrl = () => {
  const orgId = useSelector(selectOrgId)

  return useCallback((content: TWhatsappContent) => ensureFilesUrl(orgId, content), [orgId])
}
